export default __webpack_public_path__ + "static/core-values_embrace-8b728966fa7882d2823057163f3b05ab.svg";